import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-specialist-section',
  templateUrl: './specialist-section.component.html',
  styleUrls: ['./specialist-section.component.scss']
})
export class SpecialistSectionComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
